import React from 'react';
import styled from 'styled-components';

interface TelaLGPDProps {
  pesquisa: any;
  onNext: () => void;
  onPrev: () => void;
}

const Container = styled.div`
  width: 100%;
  text-align: center;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 12px;
  margin: 20px 0;
`;

const Title = styled.h1`
  color: #222222;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 30px;
`;

const Content = styled.div`
  color: #666;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 40px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  
  h1, h2, h3, h4, h5, h6 {
    color: #222222;
    margin: 20px 0 15px 0;
    font-weight: 600;
  }
  
  p {
    margin: 15px 0;
  }
  
  ul, ol {
    margin: 15px 0;
    padding-left: 25px;
    text-align: left;
  }
  
  li {
    margin: 8px 0;
  }
  
  strong {
    color: #222222;
    font-weight: 600;
  }
  
  em {
    font-style: italic;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  border: none;
  padding: 16px 32px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;
  
  ${props => props.variant === 'secondary' ? `
    background: #f8f9fa;
    color: #495057;
    border: 1px solid #dee2e6;
  ` : `
    background: #222222;
  `}
`;

const TelaLGPD: React.FC<TelaLGPDProps> = ({ pesquisa, onNext, onPrev }) => {
  const handleNext = () => {
    onNext();
    window.scrollTo(0, 0);
  };

  const handlePrev = () => {
    onPrev();
    window.scrollTo(0, 0);
  };
  const textoLGPD = pesquisa.texto_lgpd || `
    <h3>Termos de Uso e PolÃ­tica de Privacidade</h3>
    <p>Este questionário é destinado Ã  coleta de informaçÃµes de Saúde para fins de pesquisa e melhoria dos serviços oferecidos.</p>
    
    <h4>Coleta de Dados:</h4>
    <p>Coletamos informaçÃµes pessoais e de Saúde necessárias para:</p>
    <ul>
      <li>Análise estatÃ­stica e pesquisa</li>
      <li>Melhoria dos serviços de Saúde</li>
      <li>Personalização do atendimento</li>
    </ul>
    
    <h4>Uso dos Dados:</h4>
    <p>Suas informaçÃµes serão utilizadas exclusivamente para:</p>
    <ul>
      <li>Pesquisas cientÃ­ficas e estatÃ­sticas</li>
      <li>Desenvolvimento de polÃ­ticas de Saúde</li>
      <li>Melhoria da qualidade dos serviços</li>
    </ul>
    
    <h4>Proteção dos Dados:</h4>
    <p>Garantimos que suas informaçÃµes serão:</p>
    <ul>
      <li>Mantidas em segurança e confidencialidade</li>
      <li>Utilizadas apenas para os fins descritos</li>
      <li>não compartilhadas com terceiros sem consentimento</li>
    </ul>
    
    <p><strong>Ao continuar, você concorda com o uso dos seus dados conforme descrito acima.</strong></p>
  `;

  return (
    <Container>
      <Content dangerouslySetInnerHTML={{ __html: textoLGPD }} />
      <ButtonContainer>
        <Button variant="secondary" onClick={handlePrev}>
          Voltar
        </Button>
        <Button onClick={handleNext}>
          Eu Concordo
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default TelaLGPD;
